export enum LogDisplayMode {
  console,
  debug,
  soft,
  none
}
